import React from "react";
import { NavLink, Navigate, Outlet } from "react-router-dom";
import { LayoutDashboard, Receipt, Search, ScrollText, Gift, ShieldAlert, Loader2, FileEdit } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const NAV = [
  { to: "/admin",          end: true, icon: LayoutDashboard, label: "Dashboard" },
  { to: "/admin/orders",   icon: Receipt,    label: "Donaciones" },
  { to: "/admin/search",   icon: Search,     label: "Buscar Player" },
  { to: "/admin/claims",   icon: Gift,       label: "Claims" },
  { to: "/admin/audit",    icon: ScrollText, label: "Auditoria" },
  { to: "/admin/content",  icon: FileEdit,   label: "Contenido Sitio" },
];

export default function AdminLayout() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <main className="bg-[#0a0a0d] min-h-screen pt-32 flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#d4a843]" />
      </main>
    );
  }
  if (!user) return <Navigate to="/account" replace />;
  if (!user.is_admin) {
    return (
      <main className="bg-[#0a0a0d] min-h-screen pt-32 pb-20 flex items-center justify-center">
        <div className="max-w-md text-center border border-red-900/40 bg-red-950/20 rounded-lg p-8">
          <ShieldAlert className="w-12 h-12 text-red-500 mx-auto mb-3" />
          <h2 className="text-xl text-white font-semibold mb-2">Acceso restringido</h2>
          <p className="text-sm text-[#b8b3a8]">
            Esta zona es solo para administradores. Tu cuenta no tiene los permisos necesarios.
          </p>
        </div>
      </main>
    );
  }

  return (
    <main className="bg-[#0a0a0d] min-h-screen pt-24 pb-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 grid grid-cols-1 lg:grid-cols-[220px_1fr] gap-6">
        <aside className="lg:sticky lg:top-24 self-start">
          <div className="ornament mb-3"><span>Admin Panel</span></div>
          <div className="text-xs text-[#7e7768] mb-4 uppercase tracking-wider">
            Sesion: <span className="text-[#d4a843]">{user.account}</span>
          </div>
          <nav className="flex lg:flex-col gap-1 overflow-x-auto" data-testid="admin-nav">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                data-testid={`admin-nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-3 py-2 rounded-md text-sm whitespace-nowrap transition ${
                    isActive
                      ? "bg-[#d4a843]/15 text-[#d4a843] border border-[#d4a843]/30"
                      : "text-[#b8b3a8] hover:text-white hover:bg-white/5"
                  }`
                }
              >
                <item.icon className="w-4 h-4" />
                {item.label}
              </NavLink>
            ))}
          </nav>
        </aside>
        <section className="min-w-0">
          <Outlet />
        </section>
      </div>
    </main>
  );
}
